<div class="p-grid">
	<div class="p-col-12 p-lg-4 d-flex flex-column">
		<div class="d-flex">
			<div class="h4 ms-1 mt-2 mb-1">Tip Setup</div>
		</div>
		<p-divider></p-divider>
		<div>Custom Tip</div>
		<div class="mb-3">
			<p-inputSwitch (change)="changesToSaveChange.emit(true)" [(ngModel)]="orderType.tippedCustom" [disabled]="!orderType.tipped"> </p-inputSwitch>
		</div>
	</div>
	<div class="p-col-12 p-lg-4 d-flex flex-column">
		<div>Tip Suggestion 1</div>
		<div class="mb-3">
			<p-inputNumber
				styleClass="w-100"
				[(ngModel)]="orderType.tip1"
				[disabled]="!orderType.tipped"
				mode="decimal"
				[minFractionDigits]="2"
				[minFractionDigits]="2"
				(onInput)="changesToSaveChange.emit(true)"
			>
			</p-inputNumber>
		</div>
		<div>Tip Suggestion 2</div>
		<div class="mb-3">
			<p-inputNumber
				styleClass="w-100"
				[(ngModel)]="orderType.tip2"
				[disabled]="!orderType.tipped"
				mode="decimal"
				[minFractionDigits]="2"
				[minFractionDigits]="2"
				(onInput)="changesToSaveChange.emit(true)"
			>
			</p-inputNumber>
		</div>
		<div>Tip Suggestion 3</div>
		<div class="mb-3">
			<p-inputNumber
				styleClass="w-100"
				[(ngModel)]="orderType.tip3"
				[disabled]="!orderType.tipped"
				mode="decimal"
				[minFractionDigits]="2"
				[minFractionDigits]="2"
				(onInput)="changesToSaveChange.emit(true)"
			>
			</p-inputNumber>
		</div>
	</div>
	<div class="p-col-12 p-lg-4 d-flex flex-column"></div>
</div>
